<template>
    <!-- <div class="no__print" v-show="!isPrintmode"> -->
    <div class="no__print">
        <q-header v-show="!isShow" reveal class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
            <q-toolbar style="justify-content: space-between; padding: 0 2vw">
                <div style="height: 7.17vmin; display: flex; align-items: center">
                    <q-icon name="img:/assets/images/icon/ico_back.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <div class="header_lesson q-px-sm b1" v-if="props?.type === '1'">
                        <!-- <b>학습 분석리포트 - {{ props.reportParams?.learningTypeStr + ' 학습' }} {{ props.reportParams?.level }}레벨 {{ props.reportParams?.lesson }}레슨</b> -->
                        <b>{{ typeLevLes }}</b>
                    </div>
                    <div class="header_lesson q-px-sm b1" v-if="props?.type === '2'">
                        <b>{{ satlevel }}</b>
                    </div>
                    <div class="header_lesson q-px-sm b1" v-if="props?.type === '3'"><b>진단평가 분석리포트</b></div>
                    <div class="header_lesson q-px-sm b1" v-if="props?.type === '4'">
                        <b>월간 분석리포트 - {{ setDate }}</b>
                    </div>
                    <div class="header_lesson q-px-sm b1" v-if="props?.type === '5'">
                        <b>독해력 분석리포트 - {{ props.reportParams?.kreadReportRangeNm }}</b>
                    </div>
                </div>
                <q-icon name="img:/assets/images/icon/ico_print.svg" @click="onPrint" style="width: 2.4vw; height: 2.4vw; cursor: pointer" align="right" />
            </q-toolbar>
        </q-header>
        <q-page-container v-show="!isShow">
            <q-page>
                <DailyReportContent v-if="reportData && props?.type === '1'" :reportData="reportData" :isListItem="true" @close="onClickHome" />
                <SatReportContent v-if="reportData && props?.type === '2'" :reportData="reportData" :isListItem="true" @close="onClickHome" />
                <DiagnosticReportContent v-if="reportData && props?.type === '3'" :reportData="reportData" :isListItem="true" @close="onClickHome" />
                <MonthlyReportContent v-if="reportData && props?.type === '4'" :reportData="reportData" :isListItem="true" @close="onClickHome" />
                <KreadReportContent v-if="reportData && props?.type == '5'" :reportData="reportData" :isListItem="true" @close="onClickHome" />
            </q-page>
        </q-page-container>
    </div>
    <div class="print_area">
        <PrintDailyReportContent v-if="reportData && props?.type === '1'" :reportData="reportData" :type-lev-les="typeLevLes" />
        <PrintSatReportContent v-if="reportData && props?.type === '2'" :reportData="reportData" :level="satlevel" />
        <PrintDiagnosticReportContent v-if="reportData && props?.type === '3'" :reportData="reportData" :isPrintMode="isPrintmode" :isAnalysisMenu="isAnalysisMenu" />
        <printReportContent v-if="reportData && props?.type === '4'" :reportData="reportData" :isPrintMode="isPrintmode" />
        <PrintKreadReportContent v-if="reportData && props?.type === '5'" :reportData="reportData" />
        <!-- 프린트 페이지 -->
    </div>
</template>

<script setup>
import { onMounted, ref, watch, toRaw, computed } from 'vue';
import _ from 'lodash';
import { StudyStore } from '@/store/modules/study';
import { useRouter } from 'vue-router';
import { learningType } from '@/helpers/qbankParser/qbankMeta';
import DailyReportContent from './dailyReport/reportContent.vue';
import PrintDailyReportContent from './dailyReport/printReportContent.vue';
import PrintSatReportContent from './satReport/printReportContent.vue';
import PrintDiagnosticReportContent from './diagnosticReport/printReportContent.vue';
import PrintKreadReportContent from './kreadReport/printReportContent.vue';
import SatReportContent from './satReport/reportContent.vue';
import DiagnosticReportContent from './diagnosticReport/reportContent.vue';
import KreadReportContent from './kreadReport/reportContent.vue';
import MonthlyReportContent from './monthly/reportContent.vue';
import printReportContent from './monthly/printReportContent.vue';
import { getReportSat, getReportArea, getReportAreaSuggestion, getReportDiagnostic, getReportKread, getReportMonthlyAnalysisData } from '@/api/modules/study';
import { GlobalStore } from '@/store';
import { useRoute } from 'vue-router';
import Comm from '@/components/common';

const gStore = GlobalStore();
const studyStore = StudyStore();
const router = useRouter();
const route = useRoute();
const reportParam = ref(null);
const isShow = ref(false);
const reportData = ref(null);
const isPrintmode = ref(false);
const isAnalysisMenu = ref(false);

const emit = defineEmits(['close']);

// 주석 삭제

const satlevel = computed(() => {
    return '수능모의평가 분석리포트 - ' + props.reportParams?.level.split(' ').slice(0, 2).join(' ');
});

const typeLevLes = computed(() => {
    return '학습 분석리포트 - ' + props.reportParams?.learningTypeStr + '학습 ' + props.reportParams?.level + '레벨 ' + props.reportParams?.lesson + '레슨';
});

const props = defineProps({
    reportParams: { default: null },
    type: { default: '1' },
});
const getData = (params) => {
    if (props?.type === '1') {
        // console.log(params?.learningHistorySeqs);
        if (params?.learningHistorySeqs) {
            getReportAreaSuggestion({ learningHistorySeqs: params?.learningHistorySeqs }, (rs) => {
                reportData.value = rs;
            });
        } else {
            // console.log(params);
            getReportArea({ ...params }, (rs) => {
                reportData.value = rs;
            });
        }
    }
    if (props?.type === '2') {
        getReportSat({ learningHistorySeq: params?.learningHistorySeq }, (rs) => {
            // getReportSat({ learningHistorySeq: 3187, studentSeq: 178 }, (rs) => {
            reportData.value = rs;
        });
    }
    if (props?.type === '3') {
        getReportDiagnostic({ diagnosticSeq: params.diagnosticSeq }, (rs) => {
            reportData.value = rs;
        });
    }

    if (props?.type === '4') {
        setDate = params.groupNo.substring(0, 4) + '년 ' + params.groupNo.substring(4, 6) + '월';
        findDate = new Date(params.groupNo.substring(0, 4), params.groupNo.substring(4, 6), 0);
        findDate = params.groupNo.substring(0, 4) + '-' + params.groupNo.substring(4, 6) + '-01 ~ ' + params.groupNo.substring(0, 4) + '-' + params.groupNo.substring(4, 6) + '-' + findDate.getDate();
        getReportMonthlyAnalysisData(
            {
                studentSeq: params.studentSeq,
                groupNo: params.groupNo,
            },
            (rs) => {
                reportData.value = {
                    data: rs,
                    setDate: setDate,
                    findDate: findDate,
                };
            },
        );
    }
    if (props?.type === '5') {
        getReportKread({ level: params.levelOrd, lesson: params.lessonStartOrd }, (rs) => {
            reportData.value = rs;
            console.log('5');
        });
    }
};
let setDate = '';
let findDate = '';

onMounted(() => {
    // console.log(props);
    // console.log(props.reportParams.value);
    const reportParam = toRaw(props.reportParams);
    // console.log(reportParam);
    isAnalysisMenu.value = route.path === '/analysisreport' ? true : false;
    if (reportParam) {
        getData(reportParam);
    }
});

watch(
    () => props.reportParams,
    (newValue) => {
        // console.log(props.reportParams);
        const reportParam = toRaw(props.reportParams);

        if (reportParam) {
            getData(reportParam);
        }
    },
);

const userAgent = navigator.userAgent.toLowerCase();
const onPrint = () => {
    isPrintmode.value = true;
    // 맥 권한 추가
    if (userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1) {
        console.log('userAgent :::::::: pc');
        setTimeout(() => {
            window.print();
        }, 500);
    } else {
        Comm.getPrint();
    }
};

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    // store.openConfirmDialog({
    //   message: '홈으로 이동하시겠습니까?',
    //   cancel: '닫기',
    //   ok: '확인',
    //   callback: checkConfirm,
    // });
    emit('close');
};
</script>

<style scoped lang="scss">
.print_area {
    visibility: hidden;
    position: absolute;
    right: 0;
    // display: contents;

    // visibility: visible;
    // display: block;
}

.no__print {
    visibility: visible;
    display: block;
    // visibility: hidden;
    // display: none;
}

@media print {
    .no__print {
        visibility: hidden;
        display: none;
    }

    .print_area {
        visibility: visible;
        display: contents;
        margin-bottom: 10px;
    }
}
</style>
